<script setup lang="ts">
import { StatusVariant } from '@/munio/definitions'

defineProps<{
  type?: StatusVariant | 'done' | 'ok'
  outlined?: boolean
}>()
</script>

<template>
  <span
    class="mdl-label"
    :class="{
      'mdl-label--primary': type === 'primary',
      'mdl-label--accent': type === 'accent',
      'mdl-label--success': ['success', 'done', 'ok'].includes(type),
      'mdl-label--danger': type === 'danger',
      'mdl-label--info': type === 'info',
      'mdl-label--warning': type === 'warning',
      'mdl-label--outline': outlined,
    }"
  >
    <slot />
  </span>
</template>
